// Practice areas data for Lawfields Solicitors
export const PRACTICE_AREAS = [
  {
    id: "immigration",
    title: "Immigration",
    overline: "01 / Cross-Border",
    description:
      "From spouse visas to asylum appeals, we guide individuals and families through every stage of UK immigration.",
    services: [
      "Ancestry Visas",
      "Asylum Applications & Appeals",
      "Bail Applications",
      "Business Visas",
      "Domestic Violence Concession Applications",
      "Elderly Dependent Visas",
      "Entry Clearance",
      "EU Residence",
      "Humanitarian Protection & Discretionary Leave",
      "Human Rights Appeals",
      "Partner Concession Applications & Appeals",
      "Naturalisation",
      "Out of Country Spouse Visas",
      "Overstaying / Illegally in the UK",
      "Sponsorships",
      "Visitors Visas",
      "Work Permit Applications",
    ],
  },
  {
    id: "family",
    title: "Family & Child Care Law",
    overline: "02 / Personal Matters",
    description:
      "Sensitive, decisive representation in matters that shape your family's future.",
    services: [
      "Child Care Applications",
      "Divorce / Contested Divorce Proceedings",
      "Domestic Violence",
      "Enforcement Applications",
      "Financial Matters",
      "Injunctions (Non-Molestation Orders)",
      "Protection against Harassment",
    ],
  },
  {
    id: "crime",
    title: "Crime",
    overline: "03 / Defence",
    description:
      "Robust criminal defence at police stations, magistrates' and crown courts — available when it matters most.",
    services: [
      "Police Station Representation",
      "Magistrates' Court Hearings",
      "Crown Court Proceedings",
      "Bail Applications",
      "Driving Offences",
      "Appeals & Sentencing",
    ],
  },
  {
    id: "employment",
    title: "Employment Law",
    overline: "04 / Workplace",
    description:
      "Clear, practical advice for employees and small businesses navigating workplace disputes and changes.",
    services: [
      "Unfair & Constructive Dismissal",
      "Discrimination Claims (Race, Sex, Age, Disability)",
      "Settlement Agreements",
      "Redundancy & Restructuring",
      "Workplace Grievances & Disciplinaries",
      "Whistleblowing Claims",
      "Employment Contract Disputes",
      "Employment Tribunal Representation",
    ],
  },
  {
    id: "civil",
    title: "Civil Litigation",
    overline: "05 / Disputes",
    description:
      "Pragmatic dispute resolution — from debt recovery to landlord-tenant proceedings.",
    services: ["Debt Recovery", "Landlord & Tenant Matters"],
  },
];

export const PARTNERS = [
  {
    name: "Mandip Hayre",
    role: "Partner / Director",
    email: "mandip@lawfields.co.uk",
    mobile: "07813 506291",
    initials: "MH",
  },
  {
    name: "Baljit Somal",
    role: "Partner",
    email: "baljit@lawfields.co.uk",
    mobile: "07594 338388",
    initials: "BS",
  },
];

export const FIRM = {
  name: "Lawfields Solicitors",
  phone: "020 8574 0800",
  email: "info@lawfields.co.uk",
  address: "47 North Road, Southall, Middlesex UB1 2JL",
  sra: "316284",
  walkInHours: "Monday – Friday  ·  9:30am – 4:30pm",
  logo: "https://customer-assets.emergentagent.com/job_d6774f71-ee62-4ddc-ab7e-f462c3ef4c23/artifacts/cb58om02_Lawfields_Logo.png",
  cyberBadge: "https://customer-assets.emergentagent.com/job_d6774f71-ee62-4ddc-ab7e-f462c3ef4c23/artifacts/dupiytjs_Cyber-Essentials.png",
  brandPattern: "https://customer-assets.emergentagent.com/job_d6774f71-ee62-4ddc-ab7e-f462c3ef4c23/artifacts/y8ns7lwg_lawfields.png",
  heroBg: "https://static.prod-images.emergentagent.com/jobs/d6774f71-ee62-4ddc-ab7e-f462c3ef4c23/images/41f757b518d0eb7b861bbfd607df24c7c2b509090713043820e8f14a2f83decd.png",
  walkInBg: "https://static.prod-images.emergentagent.com/jobs/d6774f71-ee62-4ddc-ab7e-f462c3ef4c23/images/408c1c1887201e0cba19a9285fe03577b3e046e8467f348522a9125999bf5b36.png",
  legalOffice: "https://images.unsplash.com/photo-1568092806323-8ec13dfa9b92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBsZWdhbCUyMG9mZmljZXxlbnwwfHx8fDE3Nzg4MDE4ODd8MA&ixlib=rb-4.1.0&q=85",
  londonArch: "https://images.unsplash.com/photo-1532444143931-9f60a76242e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxsb25kb24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc4ODAxODg3fDA&ixlib=rb-4.1.0&q=85",
};
